const modalDenuncia = {
  avisoDuplicado: 'Ingresá el enlace',
  textArea: 'Contanos que pasó',
}

export default modalDenuncia
